import React, { useState, useEffect, useContext, useRef } from "react";
import { Input, Button, Row, Col, Pagination } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { renderFile } from "../../../Chats/renderFile";
import FileUpload from "../../../Chats/FileUpload/FileUpload";
import { SocketContext } from "../../../../context/SocketContext";
import DocumentCard from "./DocumentCard";
import "./MilestoneDocuments.css";

import { useTranslation } from "react-i18next";
export const MilestoneDocument = ({ milestone }) => {
  const { t } = useTranslation("dashboard");
  const socket = useContext(SocketContext);
  const [comment, setComment] = useState("");
  const [docsArray, setDocsArray] = useState([]);
  const [uploadedFile, setUploadedFile] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const pageSize = 20;
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (!socket || !milestone?._id) return undefined;
    // The socket may be in several milestones' rooms; only this one's events apply.
    const mine = value => String(value?._id ?? value) === String(milestone._id);
    const onPage = ({ docs, totalDocs, page }) => {
      setDocsArray(docs);
      setTotalDocs(totalDocs);
      setCurrentPage(page);
    };
    const onNew = doc => mine(doc?.milestone) && setDocsArray(prev => [doc, ...prev]);
    const onComment = doc => {
      if (!doc?._id || !mine(doc.milestone)) return;
      setDocsArray(prev =>
        prev?.map(d => (d?._id === doc._id ? { ...d, comments: doc.comments } : d))
      );
      scrollToBottom();
    };
    const onDelete = id => setDocsArray(prev => prev?.filter(d => d?._id !== id));
    socket.on("milestone-documents", onPage);
    socket.on("new-milestone-document", onNew);
    socket.on("new-comment-added", onComment);
    socket.on("delete-milestone-document", onDelete);
    fetchDocuments(1);
    return () => {
      socket.off("milestone-documents", onPage);
      socket.off("new-milestone-document", onNew);
      socket.off("new-comment-added", onComment);
      socket.off("delete-milestone-document", onDelete);
    };
  }, [socket, milestone?._id]);

  const fetchDocuments = page => {
    socket.emit("getDocuments", { milestone: milestone?._id, page, limit: pageSize });
  };

  const uploadDocument = async () => {
    if (uploadedFile) {
      socket.emit("uploadDocument", {
        milestone: milestone?._id,
        message: comment,
        file: uploadedFile
      });
      sendUpdate("A new document is uploaded");
      setUploadedFile({});
      setComment("");
    }
  };

  const sendUpdate = async message => {
    if (message) {
      socket.emit("sendProjectUpdate", { milestone: milestone?._id, message });
    }
  };

  const deleteDoc = async id => {
    if (id) {
      socket.emit("deleteDocument", { id });
    }
  };

  const addComment = async (docId, newComment) => {
    socket.emit("addCommentToDocument", { comment: newComment, documentId: docId });
    setComment("");
  };

  return (
    <div className="milestone-docs">
      {uploadedFile && <div className="milestone-docs__preview">{renderFile(uploadedFile)}</div>}
      <div className="milestone-docs__composer">
        <FileUpload value={uploadedFile} updateFileFun={val => setUploadedFile(val)} />
        <Input
          className="milestone-docs__title-input"
          value={comment}
          onChange={e => setComment(e.target.value)}
          placeholder={t("Type image title here")}
          aria-label={t("Type image title here")}
        />
        <Button type="primary" icon={<SendOutlined />} onClick={uploadDocument}>
          {t("Upload")}
        </Button>
      </div>
      <Row className="milestone-docs__list" gutter={[16, 16]}>
        {docsArray?.map(
          (doc, index) =>
            doc?.file && (
              <Col key={index} xs={24}>
                <DocumentCard milestone={milestone} doc={doc} />
                {/* <Card className='w-100'>
                                <div>
                                    <div className='d-flex justify-content-end'><DeleteModal text="Document" onClick={() => deleteDoc(doc?._id)} /></div>
                                    <div className='mt-3 text-center' style={{ maxHeight: "400px" }}>
                                        {renderFile(doc?.file)}
                                    </div>
                                    <p className='my-2'>{doc?.message}</p>
                                    {
                                        doc?.comments?.length > 0 &&
                                        <Collapse accordion>
                                            <Collapse.Panel header={`Comments (${doc?.comments?.length})`} key="1">
                                                <List
                                                    style={{ maxHeight: "400px", overflowY: "auto" }}
                                                    header={t("Comments")}
                                                    dataSource={doc?.comments || []}
                                                    renderItem={(item) => {
                                                        let getUser = milestone?.team?.filter(t => t?._id === item?.sender)[0];
                                                        let sender;
                                                        if (getUser?._id) {
                                                            sender = getUser?.firstName + " " + getUser?.lastName;
                                                        } else if (item?.sender === isAuthenticated()?.serviceProviderId) {
                                                            sender = isAuthenticated()?.firstName + " " + isAuthenticated()?.lastName;
                                                        }

                                                        return (
                                                            <div ref={messagesEndRef}>
                                                                <Comment avatar={<Avatar icon={<FaUser />} />} author={sender && sender} content={item?.comment} />
                                                            </div>
                                                        )
                                                    }}
                                                />
                                            </Collapse.Panel>
                                        </Collapse>
                                    }
                                    <Space.Compact
                                        style={{
                                            width: '100%',
                                            marginTop: "15px"
                                        }}
                                    >
                                        <Input allowClear onChange={(e) => setComment(e.target.value)} value={comment} placeholder='Comment here....' />
                                        <Button type="primary" className='pb-1 h-auto' onClick={() => addComment(doc?._id, comment)}>{t("Add Comment")}</Button>
                                    </Space.Compact>
                                </div>
                            </Card> */}
              </Col>
            )
        )}
      </Row>
      <div className="milestone-docs__pagination">
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={totalDocs}
          onChange={page => fetchDocuments(page)}
        />
      </div>
    </div>
  );
};
